$(document).on("click", "#device-license", function () {
  let deviceLicense = $(this).data('device-license')
  navigator.clipboard.writeText(deviceLicense)
  this.innerText = "License copied to clipboard!"
})
